import {
  get,
  ApiResponse,
  ApiResponseData,
} from 'utils/apis/insuranceLounge'

import {
  CacheResponse,
  GenericAction,
} from 'state/types'

import {
  ActionTypes,
  AccidentDescriptionOptionsByType,
} from 'state/attributes/accidentDescriptionOptions/types'

const {
  CACHE_ACCIDENT_DESCRIPTION_OPTIONS_BEGIN,
  CACHE_ACCIDENT_DESCRIPTION_OPTIONS_SUCCESS,
  CACHE_ACCIDENT_DESCRIPTION_OPTIONS_FAILURE,
} = ActionTypes

const fetchAccidentDescriptionOptions = async (): Promise<AccidentDescriptionOptionsByType> => {
  const accidentDescriptionOptions: ApiResponse = await get('/attributes/accident-descriptions')

  if (!accidentDescriptionOptions.success) {
    throw accidentDescriptionOptions
  }

  return {
    accident: [],
    loss: [],
    violation: [],
    ...accidentDescriptionOptions.data,
  } as AccidentDescriptionOptionsByType
}

// eslint-disable-next-line import/prefer-default-export
export const cacheAllAccidentDescriptionOptions = () => async (dispatch: Function, getState: Function): CacheResponse => {
  if (getState().attributes.accidentDescriptionOptions.cached || getState().attributes.accidentDescriptionOptions.loading) {
    return true
  }

  dispatch(cacheAccidentDescriptionOptionsBegin())

  return await fetchAccidentDescriptionOptions()
    .then((accidentDescriptionOptions: AccidentDescriptionOptionsByType): void => {
      const newAccidentDescriptionOptions = {} as AccidentDescriptionOptionsByType
      if (accidentDescriptionOptions) {
        Object.keys(accidentDescriptionOptions).map((key: string): void => {
          newAccidentDescriptionOptions[key] = accidentDescriptionOptions[key].map((accidentDesc: string): object => {
            return {
              key: accidentDesc,
              value: accidentDesc,
            }
          })

          return
        })
      }

      dispatch(cacheAccidentDescriptionOptionsSuccess(newAccidentDescriptionOptions))
    })
    .catch(error => {
      dispatch(cacheAccidentDescriptionOptionsFailure(error))

      return Promise.reject(error.message || 'Unable to cache accidentDescriptionOptions.')
    })
}

const cacheAccidentDescriptionOptionsBegin = (): GenericAction => ({ type: CACHE_ACCIDENT_DESCRIPTION_OPTIONS_BEGIN })

const cacheAccidentDescriptionOptionsSuccess = (accidentDescriptionOptions: AccidentDescriptionOptionsByType): GenericAction => ({
  type: CACHE_ACCIDENT_DESCRIPTION_OPTIONS_SUCCESS,
  payload: { accidentDescriptionOptions },
})

const cacheAccidentDescriptionOptionsFailure = (error: ApiResponseData): GenericAction => ({
  type: CACHE_ACCIDENT_DESCRIPTION_OPTIONS_FAILURE,
  payload: { error },
})
